import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Building2 } from 'lucide-react';
import { useUserContext } from '../context/UserContext';
import { ROUTES } from '../routes';
import { Autocomplete } from '../components/ui';

// Available brands - hardcoded for now
// TODO: Fetch from API when MApp SDK brand endpoint is available
const AVAILABLE_BRANDS = [
  { id: 'TBC', name: 'Taco Bell' },
  { id: 'PH', name: 'Pizza Hut' },
  { id: 'PH-US', name: 'Pizza Hut US' },
  { id: 'KFC', name: 'KFC' },
];

export function SelectBrandPage() {
  const navigate = useNavigate();
  const { brandId, setBrandContext } = useUserContext();
  const [selectedBrand, setSelectedBrand] = useState(brandId ?? '');
  const [error, setError] = useState<string | null>(null);

  const handleContinue = () => {
    if (!selectedBrand) {
      setError('Please select a brand.');
      return;
    }
    setBrandContext(selectedBrand);
    navigate(ROUTES.COMPLAINTS, { replace: true });
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl border border-gray-200 shadow-sm p-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center">
            <Building2 className="w-5 h-5 text-gray-600" />
          </div>
          <div>
            <h1 className="text-lg font-semibold text-gray-900">Select a brand</h1>
            <p className="text-sm text-gray-500">Brand context is required to use the app.</p>
          </div>
        </div>

        <div className="mt-6 space-y-2">
          <Autocomplete
            label="Brand"
            options={AVAILABLE_BRANDS.map((b) => ({ value: b.id, label: `${b.name} (${b.id})` }))}
            value={selectedBrand}
            onChange={(v) => {
              setSelectedBrand(v);
              if (error) setError(null);
            }}
            placeholder="Search or select a brand..."
            error={error ?? undefined}
            data-testid="brand-select-dropdown"
            id="brand-select"
          />
        </div>

        <div className="mt-6 flex items-center gap-3">
          <button
            type="button"
            data-testid="brand-select-continue"
            onClick={handleContinue}
            className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-primary-600 rounded-lg hover:bg-primary-700 transition-colors"
          >
            Continue
          </button>
          <button
            type="button"
            onClick={() => {
              setBrandContext(null);
              setSelectedBrand('');
              setError(null);
            }}
            className="px-4 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  );
}
